export function resetBoardForNewGameFromTypeScript(reason: string = 'reset'): { handled: boolean } {
  try {
    const root = document.getElementById('beatline-app');
    if (root) {
      root.classList.remove(
        'perfect-order', 'perfect-ended', 'time-attack', 'timeattack', 'speedrun', 'survival',
        'is-playing', 'is-qr-mode', 'offline-game-over'
      );
    }

    // Stop/clear transient center UI so returning to the start screen is a true clean state.
    const centerIntervention = document.getElementById('center-intervention') as HTMLElement | null;
    if (centerIntervention) {
      if (centerIntervention.contains(document.activeElement)) (document.activeElement as HTMLElement | null)?.blur?.();
      centerIntervention.style.display = 'none';
      centerIntervention.setAttribute('aria-hidden', 'true');
      centerIntervention.classList.remove('is-open', 'is-active');
    }

    ['bonus-modal', 'win-modal', 'info-modal', 'profile-modal', 'beatline-leave-modal'].forEach((id) => {
      const el = document.getElementById(id) as HTMLElement | null;
      if (el) {
        if (el.contains(document.activeElement)) (document.activeElement as HTMLElement | null)?.blur?.();
        el.style.display = 'none';
        el.setAttribute('aria-hidden', 'true');
      }
    });

    const deck = document.getElementById('deck-zone') as HTMLElement | null;
    if (deck) {
      deck.innerHTML = '';
      deck.classList.remove('has-card', 'card-active', 'is-active', 'playing', 'paused');
    }

    // Critical fix: after leaving a multiplayer game and starting solo/special mode without
    // a full page refresh, old player zones/timelines must not remain visible.
    for (let i = 1; i <= 4; i += 1) {
      const zone = document.getElementById(`zone-p${i}`) as HTMLElement | null;
      const timeline = document.getElementById(`timeline-p${i}`) as HTMLElement | null;
      const stats = document.getElementById(`stats-p${i}`) as HTMLElement | null;
      if (timeline) {
        timeline.innerHTML = '';
        timeline.classList.remove('timeline-compact', 'sortable-chosen', 'sortable-ghost', 'sortable-drag');
      }
      if (zone) {
        zone.style.display = 'none';
        zone.style.order = '';
        zone.classList.remove('zone-active', 'zone-dimmed', 'is-active', 'has-pending', 'perfect-correct', 'perfect-wrong');
      }
      if (stats) {
        stats.classList.remove('visible', 'active', 'is-active');
        const score = stats.querySelector('.score');
        const tokens = stats.querySelector('.tokens');
        if (score) score.textContent = '0';
        if (tokens) tokens.textContent = '0';
      }
    }

    const activeScorePanel = document.getElementById('active-score-panel') as HTMLElement | null;
    if (activeScorePanel) {
      activeScorePanel.style.display = '';
      activeScorePanel.classList.remove('is-complete');
      const count = document.getElementById('active-score-count');
      const needed = document.getElementById('active-score-needed');
      if (count) count.textContent = '0/10';
      if (needed) needed.innerHTML = '<span class="active-score-panel__needed-word">NOG</span><strong class="active-score-panel__needed-number">10</strong><span class="active-score-panel__needed-word">NODIG</span>';
    }

    const btnNext = document.getElementById('btn-next') as HTMLButtonElement | null;
    const btnCheck = document.getElementById('btn-check') as HTMLButtonElement | null;
    const btnReplay = document.getElementById('btn-replay-center') as HTMLButtonElement | null;
    if (btnNext) {
      btnNext.style.display = 'flex';
      btnNext.disabled = false;
      btnNext.style.pointerEvents = 'auto';
    }
    if (btnCheck) {
      btnCheck.style.display = 'none';
      btnCheck.disabled = false;
      btnCheck.style.pointerEvents = 'auto';
    }
    if (btnReplay) {
      btnReplay.style.display = 'none';
      btnReplay.disabled = false;
      btnReplay.style.pointerEvents = 'auto';
    }

    const timer = document.getElementById('timeattack-timer') as HTMLElement | null;
    if (timer) {
      timer.style.display = 'none';
      timer.textContent = '00:00';
    }
    document.querySelectorAll<HTMLElement>('.survival-lives, #survival-lives').forEach((el) => {
      el.style.display = 'none';
      el.textContent = '❤️❤️❤️';
    });

    document.body.classList.remove('beatline-dragging', 'beatline-noscroll');
    document.documentElement.classList.remove('beatline-noscroll');
    return { handled: true };
  } catch (error) {
    try { console.warn('[BeatLine Vite C27] resetBoardForNewGame failed', reason, error); } catch (_) {}
    return { handled: false };
  }
}
